import Checkbox from "../../../../../components/common/Checkbox/Checkbox";
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent";
import styles from "./PaymentOptions.module.scss";

const PaymentOptions = () => {
  const data = [
    { type: "Bank Account" },
    { type: "Debit/Credit Card" },
    { type: "Maelano Wallet" },
    { type: "Jazzcash/ Easypaisa" },
    { type: "Paypal" },
  ];

  const columns = [
    { name: "Type", selector: (row) => row.type, minWidth: "160px" },
    { name: "Added", cell: () => <Checkbox />, center: true },
    { name: "Preferred", cell: () => <Checkbox />, center: true },
    {
      name: "Action",
      cell: () => <span className="cursor-pointer">View</span>,
    },
  ];

  return (
    <div className="py-3">
      <div className={styles["heading"]}>Payment Options</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <DatatableComponent data={data} columns={columns} type={"gray"} />
        </div>
      </div>
    </div>
  );
};

export default PaymentOptions;